module.exports = __webpack_public_path__ + "assets/9e87799134f234c38d4fb389146a50a3.png";